module.exports = __webpack_public_path__ + "static/media/5_screen.d4ea36b1.png";